import { Edit, SimpleForm, TextInput, SelectInput, minLength } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { layout } from '../styles/ds';

const ROLE_CHOICES = [
  { id: 'staff', name: 'צוות' },
  { id: 'admin', name: 'מנהל/ת' },
];

const UserEdit = () => (
  <Edit title="עריכת משתמש">
    <SimpleForm>
      <Box sx={layout.formGrid}>
        <TextInput source="username" label="שם משתמש" fullWidth disabled />
        <SelectInput source="role" label="תפקיד" choices={ROLE_CHOICES} fullWidth />
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
        להשארת הסיסמא הקיימת — השאירי את השדה ריק
      </Typography>
      <TextInput source="password" label="סיסמא חדשה (אופציונלי)" type="password" fullWidth
        validate={minLength(8, 'לפחות 8 תווים')} />
    </SimpleForm>
  </Edit>
);

export default UserEdit;
